import BrieIconSrc from "assets/img/icons/common/icon_Brie_Green_Outlined.svg";

const BrieIconGreenOutlined = ({ transform }: { transform?: string }) => {
  return (
    <img
      src={BrieIconSrc}
      style={transform ? { transform: transform } : undefined}
      alt="ICON"
    ></img>
  );
};

export default BrieIconGreenOutlined;
